import Highcharts from 'highcharts';
import { type TimelineAxisSide, type TimelineDateSeries, TimelineSeriesCustomData } from '../../../shared';
import { mapDateRangeSeries } from './map-date-range-series';
import { mapSingleDateSeries } from './map-single-date-series';
// @ts-expect-error @types collides with node_modules/@types
import { TimelineDateSeriesType } from '@types/graphql-global-types';

function createCounter() {
    let i = 0;

    return () => {
        return i++;
    };
}

type MapDateSeriesOptions = {
    allSeries: TimelineDateSeries[];
    side: TimelineAxisSide;
    pointEvents?: Highcharts.PointEventsOptionsObject;
};
export function mapAllDateSeries({
    allSeries,
    side,
    pointEvents,
}: MapDateSeriesOptions): (Highcharts.SeriesOptionsType & TimelineSeriesCustomData)[] {
    // Function which gets y offset for series and increments offset for next call, e.g.
    // - Single date series calls it once for 0.
    // - Date range series with 2 lanes calls it twice for 1, 2
    // - Date range series with 1 lane calls it once for 3
    // and so on...
    const getYOffset = createCounter();

    // Map each series data to highcharts chart data points
    return allSeries.map((series, i) => {
        const sharedOptions = {
            id: `${side}_series${i}`,
            yAxis: side,
            name: series.series.label,
            point: {
                events: pointEvents,
            },
        } satisfies Partial<Highcharts.SeriesOptionsType>;

        switch (series.series.type) {
            case TimelineDateSeriesType.DATE_RANGE:
                return {
                    ...sharedOptions,
                    ...mapDateRangeSeries({ series, getYOffset }),
                } satisfies Highcharts.PlotXrangeOptions & TimelineSeriesCustomData;

            case TimelineDateSeriesType.SINGLE_DATE:
                return {
                    ...sharedOptions,
                    ...mapSingleDateSeries({ series, getYOffset }),
                } satisfies Highcharts.SeriesScatterOptions & TimelineSeriesCustomData;

            default:
                throw new Error(`Unknown timeline date series type: "${series.series.type}"`);
        }
    });
}
